import { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { faPlus, faArrowRight, faArrowLeft, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import './communication-creator.css';
import { get_ads, loadImageFromUrl, deleteCommunication } from '../../../modules/communication';

import { toast } from 'react-toastify';
import moment from 'moment';
import FilterSection from './filter-section.tsx';

class CommunicationCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navigate: '',
      loading: false,
      totalNumOfAds: 0,
      offset: 0,
      limit: 5,
      communications: [],
      query: '',
      filterType: -1,
    };
  }

  componentDidMount() {
    this.setState({ ...this.state });
    const { offset } = this.state;
    this.getAds(offset);
  }

  updateFilterType(newFilterType) {
    this.setState({ filterType: newFilterType });
  }
  updateQuery(newQuery) {
    this.setState({ query: newQuery });
  }

  submitSearch(event) {
    event.preventDefault();
    const { offset } = this.state;
    this.getAds(offset);
  }

  async getAds(offset) {
    const { limit, query, filterType } = this.state;

    this.setState({ loading: true });

    try {
      const response = await get_ads(query, filterType, offset, limit);
      this.setState({
        ...this.state,
        loading: false,
        communications: response.data.communications,
        totalNumOfAds: response.data.totalNumOfAds,
      });

      await this.loadImageData();
    } catch (e) {
      console.error(e);
    }
  }

  changePage(pageNum) {
    this.setState({
      ...this.state,
      offset: pageNum,
    });
    this.getAds(pageNum);
  }

  async loadImageData() {
    const { communications } = this.state;
    for (const index in communications) {
      const response = await loadImageFromUrl(communications[index].image_filename);
      communications[index]['imageData'] = response.imageData;
    }

    this.setState({
      ...this.state,
      communications: communications,
    });
  }

  isAdCanBeDeletedOrEdited(time) {
    let timestampTime = time;

    if (typeof timestampTime === 'string') {
      timestampTime = new Date(timestampTime);
    }
    if (typeof timestampTime === 'object') {
      timestampTime = timestampTime.getTime();
    }

    const now = Date.now();

    if (timestampTime > now) {
      return true;
    } else {
      return false;
    }
  }

  async handleDelete(communication) {
    const { offset } = this.state;

    if (
      window.confirm(`You are deleting ${communication.name} communication starting on 
        ${moment(communication.start_time).format('LLL')}. Proceed?`)
    ) {
      try {
        await deleteCommunication(communication.id);
        toast.success(
          `DELETED: ${communication.name} communication on ${moment(communication.start_time).format('LLL')}.`,
          { position: toast.POSITION.TOP_CENTER }
        );
        this.getAds(offset);
      } catch (e) {
        console.error(e);
      }
    }
  }

  render() {
    const { navigate, communications, loading, offset, limit, totalNumOfAds, query, filterType } = this.state;

    const numOfPages = Math.ceil(totalNumOfAds / limit);

    if (navigate !== '') {
      return (
        <Redirect
          to={{
            pathname: navigate,
          }}
        />
      );
    }

    return (
      <div className="tw-mx-10 tw-my-5">
        <div className="tw-container tw-h-16 tw-text-left">
          <h1 className="tw-font-extrabold tw-text-2xl">I'm a Communication Creator watch me roar! 🦁</h1>
        </div>
        <div className="tw-container tw-h-10 tw-flex tw-items-left">
          <button className="tw-btn tw-btn-primary" onClick={() => this.setState({ navigate: '/communication/add' })}>
            <span>Add</span>
            &nbsp;
            <FontAwesomeIcon icon={faPlus} size="lg" />
          </button>
        </div>

        <div className="tw--mx-4 sm:tw--mx-8 tw-px-4 sm:tw-px-8 tw-py-4 tw-overflow-x-auto">
          <div className="tw-inline-block tw-min-w-full tw-shadow tw-rounded-lg">
            {loading && (
              <div className="ad-table-loader">
                <span className="loading-title">Loading</span>
                <i className="fa fa-spinner fa-spin"></i>
              </div>
            )}
            <div>
              <button
                className="tw-btn tw-btn-secondary"
                disabled={offset <= 0}
                onClick={() => {
                  this.changePage(offset - 1);
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} size="large" />
              </button>
              &nbsp;&nbsp;&nbsp;
              <label htmlFor="">
                {' '}
                {offset + 1}&nbsp;/&nbsp;{numOfPages}
              </label>
              &nbsp;&nbsp;&nbsp;
              <button
                className="tw-btn tw-btn-secondary"
                disabled={offset >= numOfPages - 1}
                onClick={() => {
                  this.changePage(offset + 1);
                }}
              >
                <FontAwesomeIcon icon={faArrowRight} size="large" />
              </button>
              <FilterSection
                query={query}
                filterType={filterType}
                updateQuery={this.updateQuery.bind(this)}
                updateFilterType={this.updateFilterType.bind(this)}
                submit={this.submitSearch.bind(this)}
              ></FilterSection>
            </div>
            {!loading && (
              <table className="tw-min-w-full tw-leading-normal">
                <thead>
                  <tr>
                    <th className="tw-th">Ad's Name</th>
                    <th className="tw-th">Description</th>
                    <th className="tw-th">Type</th>
                    <th className="tw-th">Start Date</th>
                    <th className="tw-th">End Date</th>
                    {/* <th className="tw-th">Image Name</th> */}
                    <th className="tw-th">Image</th>
                    <th className="tw-th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {communications.map((communication, i) => (
                    <tr key={i}>
                      <td className="tw-td">
                        <p className="tw-text-gray-900 tw-whitespace-no-wrap">{communication.name}</p>
                      </td>
                      <td className="tw-td">
                        <p className="tw-text-gray-900 tw-whitespace-no-wrap">{communication.description}</p>
                      </td>
                      <td className="tw-td">
                        <p className="tw-text-gray-900 tw-whitespace-no-wrap">{communication.communication_type}</p>
                      </td>
                      <td className="tw-td">
                        <p className="tw-text-gray-900 tw-whitespace-no-wrap">
                          {moment(communication.start_time).format('LLL')}
                        </p>
                      </td>
                      <td className="tw-td">
                        <p className="tw-text-gray-900 tw-whitespace-no-wrap">
                          {moment(communication.end_time).format('LLL')}
                        </p>
                      </td>
                      {/* <td className="tw-td">
                        <p className="tw-text-gray-900 tw-whitespace-no-wrap">{communication.image_filename}</p>
                      </td> */}
                      <td className="tw-td tw-rounded-lg tw-bg-white tw-shadow-lg tw-overflow-hidden tw-text-center">
                        <img className="tw-h-32 tw-object-scale-down tw-w-full" src={communication.imageData} alt="" />
                      </td>
                      <td className="tw-td">
                        <div className="tw-inline-flex">
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            onClick={() => this.setState({ navigate: `/communication/${communication.id}` })}
                            size="lg"
                            cursor="pointer"
                          />
                          &nbsp;&nbsp;
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => this.handleDelete(communication)}
                            size="lg"
                            cursor="pointer"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const withState = connect((state) => {
  const { communication } = state;
  return { ...communication };
});

export default withState(CommunicationCreator);
